
import cfImage from '@/utils/cfImage'

const IMG_BASE = 'https://blog.flightsearchdirect.com/wp-content/uploads/2023/11'

export default {
  methods: {
    cfImage,
    prefillSearch (payload) {
      this.$store.commit('setSearchFormPrefill', payload)
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  },
  data () {
    return {
      confidenceCards: [
        { key: 'direct', icon: '🎯' },
        { key: 'options', icon: '🔀' },
        { key: 'availability', icon: '🔄' }
      ],
      whoCards: [
        { key: 'business', icon: '💼' },
        { key: 'family', icon: '👨‍👩‍👧‍👦' },
        { key: 'solo', icon: '🎒' },
        { key: 'frequent', icon: '✈️' }
      ],
      routes: [
        { from: 'LHR', to: 'MAD', fromName: 'London', toName: 'Madrid', img: `${IMG_BASE}/madrid.jpg` },
        { from: 'LHR', to: 'LIS', fromName: 'London', toName: 'Lisbon', img: `${IMG_BASE}/lisbon.jpg` },
        { from: 'LHR', to: 'YYZ', fromName: 'London', toName: 'Toronto', img: `${IMG_BASE}/toronto.jpg` },
        { from: 'JFK', to: 'BER', fromName: 'New York', toName: 'Berlin', img: `${IMG_BASE}/berlin.jpg` },
        { from: 'LHR', to: 'ICN', fromName: 'London', toName: 'Seoul', img: `${IMG_BASE}/seoul.jpg` },
        { from: 'JFK', to: 'EZE', fromName: 'New York', toName: 'Buenos Aires', img: `${IMG_BASE}/buenos-aires.jpg` },
        { from: 'LHR', to: 'MEL', fromName: 'London', toName: 'Melbourne', img: `${IMG_BASE}/melbourne.jpg` },
        { from: 'CDG', to: 'IST', fromName: 'Paris', toName: 'Istanbul', img: `${IMG_BASE}/istanbul.jpg` },
        { from: 'LHR', to: 'RAK', fromName: 'London', toName: 'Marrakech', img: `${IMG_BASE}/marrakech.jpg` }
      ],
      destinations: [
        { code: 'MAD', name: 'Madrid', countryKey: 'spain', img: `${IMG_BASE}/madrid.jpg` },
        { code: 'LIS', name: 'Lisbon', countryKey: 'portugal', img: `${IMG_BASE}/lisbon.jpg` },
        { code: 'VIE', name: 'Vienna', countryKey: 'austria', img: `${IMG_BASE}/vienna.jpg` },
        { code: 'PRG', name: 'Prague', countryKey: 'czech_republic', img: `${IMG_BASE}/prague.jpg` },
        { code: 'ICN', name: 'Seoul', countryKey: 'south_korea', img: `${IMG_BASE}/seoul.jpg` },
        { code: 'YYZ', name: 'Toronto', countryKey: 'canada', img: `${IMG_BASE}/toronto.jpg` },
        { code: 'EZE', name: 'Buenos Aires', countryKey: 'argentina', img: `${IMG_BASE}/buenos-aires.jpg` },
        { code: 'RAK', name: 'Marrakech', countryKey: 'morocco', img: `${IMG_BASE}/marrakech.jpg` },
        { code: 'BER', name: 'Berlin', countryKey: 'germany', img: `${IMG_BASE}/berlin.jpg` },
        { code: 'MEL', name: 'Melbourne', countryKey: 'australia', img: `${IMG_BASE}/melbourne.jpg` },
        { code: 'LAX', name: 'Los Angeles', countryKey: 'united_states', img: `${IMG_BASE}/los-angeles.jpg` },
        { code: 'IST', name: 'Istanbul', countryKey: 'turkey', img: `${IMG_BASE}/istanbul.jpg` }
      ]
    }
  }
}
